
export enum OrgPermission {
    manage = "Manage",
    read = "Read"
  }
  
  export enum ContentPermission {
    edit = "Edit",
    view = "View",
    partial = "Partial"
  }
  
